export default __webpack_public_path__ + "static/mokuHead-37f1059a774eddb668ccea89140ad277.svg";